import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import Constants from './frontLayout/Variables/Constants';
import { setCartItems } from './redux/cartSlice';
import { toast } from 'react-toastify';

const LayoutWrapper = ({ children }) => {
    const token = localStorage.getItem("token")
    const dispatch = useDispatch();

    const fetchCart = async () => {
        try {
            const res = await axios.get(Constants.getUrls.getCart, {
                headers: { Authorization: token },
            });
            if (res.data.status === "success") {
                const data = res.data.data.docs;
                const arr = [];
                if (data && Array.isArray(data) && data.length > 0) {
                    data.map((item) => {
                        arr.push({
                            ...item,
                            product_id: item.product_id._id,
                            images: item.product_id.images,
                            name: item.product_id.name,
                            price: item.product_id.price,
                        });
                    });
                    localStorage.removeItem("cart");
                    dispatch(setCartItems(arr));
                } else {
                    dispatch(setCartItems([]));
                    localStorage.removeItem("cart");
                }
            } else {
                dispatch(setCartItems([]));
                localStorage.removeItem("cart");
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleAddToCart = (arr) => {
        try {

            axios
                .post(
                    Constants.postUrls.AddToCart,
                    arr,
                    {
                        headers: {
                            Authorization: token,
                        },
                    }
                )
                .then((resp) => {
                    if (resp.data.status === "success") {
                        localStorage.removeItem("cart");
                        fetchCart();
                    }
                })
                .catch((error) => {
                    console.error("Error while adding product to cart:", error);
                });
        } catch (error) {
            try {
                toast.clearWaitingQueue();
                toast.dismiss();
                toast.error(error.message);
                const { status, message } = error.response.data
                if (status === 401 && message === "Unauthorized!") {
                    localStorage.removeItem("token");
                    window.location.href = "/";
                }
            } catch (error) {
                toast.clearWaitingQueue();
                toast.dismiss();
                toast.error(error.message);
            }
        }
    };

    const fetchMultipleProducts = async ({ localCartData }) => {
        try {
            const productIds = localCartData.map(io => io._id)
            const resp = await axios.post(
                Constants.postUrls.getMultipleProduct,
                { product_ids: productIds },
            );
            if (resp.data.status === "success") {
                const cartData = resp.data.data
                if (cartData && Array.isArray(cartData)) {
                    cartData.map(cart => {
                        productIds.map(io => {
                            if (io._id === cart._id) {
                                cart.quantity = io.quantity
                            }
                        })
                    })

                    const arr = [];

                    cartData.map(cart => {
                        localCartData.map(io => {
                            if (io._id === cart._id) {
                                arr.push({
                                    product_id: cart._id,
                                    quantity: io.quantity
                                })
                            }
                        })
                    })

                    handleAddToCart(arr)
                }
            }
        } catch (error) {
            try {
                toast.clearWaitingQueue();
                toast.dismiss();
                toast.error(error.message);
                const { status, message } = error.response.data
                if (status === 401 && message === "Unauthorized!") {
                    localStorage.removeItem("token");
                    window.location.href = "/";
                }
            } catch (error) {
                toast.clearWaitingQueue();
                toast.dismiss();
                toast.error(error.message);
            }
        }
    };

    useEffect(() => {
        if (token) {
            const cartData = localStorage.getItem("cart")
            if (cartData) {
                const localCartData = JSON.parse(cartData);
                if (localCartData && Array.isArray(localCartData)) {
                    fetchMultipleProducts({ localCartData })
                } else {
                    fetchCart();
                }
            } else {
                fetchCart();
            }
        }
    }, [token]);
    return (
        children
    )
}

export default LayoutWrapper